import { z } from 'zod';

// Tag validation pattern: letters, numbers, '.', '_', '-'
const TAG_PATTERN = /^[.A-Za-z_\-0-9]+$/;
const MAX_TAG_LENGTH = 64;

// Zod schema for tag validation
export const tagValidator = z
  .string()
  .regex(TAG_PATTERN, "Tags must only contain letters, numbers, '-', '_', or '.'")
  .max(MAX_TAG_LENGTH, `Tag must be at most ${MAX_TAG_LENGTH} characters`);

/**
 * Validates a tag string according to backend rules.
 * Trailing spaces are allowed in the input and will be trimmed before validation.
 * @param tag - The tag string to validate
 * @returns Object with isValid boolean and optional errorMessage
 */
export function validateTag(tag: string): { isValid: boolean; errorMessage?: string } {
  const trimmedTag = tag.trimEnd();

  const result = tagValidator.safeParse(trimmedTag);

  if (result.success) {
    return { isValid: true };
  }

  return {
    isValid: false,
    errorMessage: `Tags are invalid. Tags must only contain letters, numbers, '-', '_', or '.' and be at most ${MAX_TAG_LENGTH} characters`,
  };
}
